(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('ActivityTypeInfoDialogController', ActivityTypeInfoDialogController);

    ActivityTypeInfoDialogController.$inject = ['$scope', '$state', 'ActivityTypeInfo', 'PersonInfo', 'Customer', 'ParseLinks', 'AlertService', 'entity', 'CustomerCustom', 'CouponCustom', '$mdDialog', '$translatePartialLoader', 'SubscriptionPackageCustom', 'CustomerGroupCustom', '$uibModalInstance', 'SubscriptionPackage'];

    function ActivityTypeInfoDialogController($scope, $state, ActivityTypeInfo, PersonInfo, Customer, ParseLinks, AlertService, entity, CustomerCustom, CouponCustom, $mdDialog, $translatePartialLoader, SubscriptionPackageCustom, CustomerGroupCustom, $uibModalInstance, SubscriptionPackage) {

        var vm = this;
        vm.activityTypeInfo = entity;
        vm.loadAll = loadAll;
        loadAll();
        vm.save = save;
        vm.hasAllNecessaryFields = true;
        vm.columnCount = null;
        vm.clear = clear;


        initDefault();
        loadAll();

        function initDefault() {
        }

        function loadAll() {
        }


        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;

            if (vm.activityTypeInfo.id !== null) {
                ActivityTypeInfo.update(vm.activityTypeInfo, onSaveSuccess, onSaveError);
            } else {

                ActivityTypeInfo.save(vm.activityTypeInfo, onSaveSuccess, onSaveError);

            }

            function onSaveError() {
                vm.isSaving = false;
            }

            function onSaveSuccess(result) {
                $scope.$emit('tikonApp:ActivityTypeInfoUpdate', result);
                $uibModalInstance.close(result);
                vm.isSaving = false;
            }

        }


    }
})();
